export default __webpack_public_path__ + "assets/models/3f30bda1ae07856e9a537406bd3ae10c.glb";